import { render, staticRenderFns } from "./progress-card.vue?vue&type=template&id=33305668&scoped=true"
import script from "./progress-card.vue?vue&type=script&lang=js"
export * from "./progress-card.vue?vue&type=script&lang=js"
import style0 from "./progress-card.vue?vue&type=style&index=0&id=33305668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33305668",
  null
  
)

export default component.exports